import axios from 'axios';
import { handleMockRequest } from '../data/dummyProducts';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.royalpetstore.store/api',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isNetworkError = !error.response || error.code === 'ERR_NETWORK' || error.message === 'Network Error';
    const isServerError = error.response && (error.response.status >= 500 || error.response.status === 404);
    
    if (isNetworkError || isServerError) {
      const config = error.config;
      const url = config?.url;
      const method = config?.method?.toLowerCase();
      
      if (url && method === 'get') {
        try {
          const mockResponse = handleMockRequest(url, config.params);
          if (mockResponse !== null) {
            console.warn(`[API Interceptor] Backend not connected or failed. Serving mock fallback for GET: ${url}`);
            return Promise.resolve({
              data: mockResponse,
              status: 200,
              statusText: 'OK',
              headers: {},
              config,
            });
          }
        } catch (mockErr) {
          console.error('[API Interceptor] Error generating mock response:', mockErr);
        }
      }
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
